import { Layout } from "antd";
import { useTranslation } from "react-i18next";

import BaseHeader from "@/components/Header/BaseHeader";
import { STORAGE_KEYS } from "@/constants/StorageKeys";
import LocationAddButton from "@/modules/location/location-add-button";
import LocationsListProvider from "@/modules/locations/locations-list-provider";
import LocationsListTable from "@/modules/locations/locations-list-table";

const { Content } = Layout;

const LocationsListPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <BaseHeader title={t("navigation:locations")} />
      <Content>
        <LocationsListProvider storageKey={STORAGE_KEYS.LOCATIONS}>
          <LocationsListTable extraActions={<LocationAddButton />} />
        </LocationsListProvider>
      </Content>
    </>
  );
};

export default LocationsListPage;
